// extracted by mini-css-extract-plugin
export default {"loader-aligment":"styles_loader-aligment__yZGcu","custom-layout":"styles_custom-layout__xSQzi"};